var _path, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomInMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_186",
    "data-name": "Group 186",
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.994,
    height: 52.994,
    viewBox: "0 0 52.994 52.994",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M4,0H48.994a4,4,0,0,1,4,4V48.994a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0",
    fill: "#001233"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    y1: 30.816,
    transform: "translate(26.794 11.386)",
    fill: "none",
    stroke: "#f8f3ff",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    x2: 30.816,
    transform: "translate(11.386 26.794)",
    fill: "none",
    stroke: "#f8f3ff",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomInMap);
export default __webpack_public_path__ + "static/media/zoom-in-map.0bc5b0c6f8d664615c156e6c85f437d0.svg";
export { ForwardRef as ReactComponent };